export const PLAN_DETAILS_LOADING = 'PLAN_DETAILS_LOADING';
export const GET_FULL_PLAN_DETAILS = 'GET_FULL_PLAN_DETAILS';
export const GET_PLAN_DETAILS = 'GET_PLAN_DETAILS';
export const GET_EMAIL = 'GET_EMAIL';
export const PLAN_DETAILS_ERROR = 'PLAN_DETAILS_ERROR';
